import Styleguide from "@store/Framework/Types/Styleguide";

const loadingSpinner: Styleguide["loadingSpinner"] = {
    defaultProps: {
        size: 40,
    },
};

export default loadingSpinner;
